export default "__VITE_ASSET__BZOBvZzI__"